export default "__VITE_ASSET__0c708b37__"